import React from 'react';
import { PropTypes } from 'prop-types';
import TextArea from './TextArea';

export default {
  title: 'Components/Inputs/TextArea',
  component: TextArea,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

export const TextAreaComponent = ({
  label, name,
}) => {
  const [value, setValue] = React.useState('');
  return <TextArea value={value} setValue={setValue} label={label} name={name} />;
};

TextAreaComponent.args = { label: 'Label', name: 'label' };

TextAreaComponent.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
};
